import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  MicrosoftPolicyMisconfigurationReport,
  SharedCallingRoutingPolicy,
  TeamsVoicePolicies,
} from '../../../shared/models/generated/ziroModels';

export interface TeamsPoliciesUntyped extends TeamsVoicePolicies {
  [key: string]: string | SharedCallingRoutingPolicy;
}

@Injectable()
export class PolicyMisconfigurationResource {
  private _http = inject(HttpClient);

  get(tenantId: string): Observable<MicrosoftPolicyMisconfigurationReport[]> {
    return this._http.get<MicrosoftPolicyMisconfigurationReport[]>(
      `/services/microsoft/reporting/tenants/${tenantId}/policy-misconfiguration`,
    );
  }

  refresh(tenantId: string): Observable<void> {
    return this._http.post<void>(
      `/services/microsoft/reporting/tenants/${tenantId}/policy-misconfiguration/refresh`,
      null,
    );
  }

  updateEnterpriseVoice(tenantId: number, upn: string, enterpriseVoiceEnabled: boolean): Observable<void> {
    return this._http.put<void>(
      `/services/microsoft/macs/tenants/${tenantId}/enterprise-voice/${encodeURIComponent(upn)}`,
      {
        userPrincipalName: upn,
        enterpriseVoiceEnabled,
      },
    );
  }

  updateIgnoredUsers(tenantId: string, users: string[]): Observable<void> {
    return this._http.put<void>(
      `/services/microsoft/reporting/tenants/${tenantId}/policy-misconfiguration/ignored-users`,
      {
        ignoredUsers: users,
      },
    );
  }
}
